import { render } from "./prescription.vue?vue&type=template&id=4ce53ed0&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=4ce53ed0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce53ed0"]])

export default __exports__